"use client"

import { transferCart } from "@lib/data/customer"
import { AlertCircle } from "lucide-react"
import { StoreCart, StoreCustomer } from "@medusajs/types"
import { Button } from "@/components/common"
import { useEffect, useRef, useState } from "react"
import { useRouter } from "next/navigation"
import { useTranslations } from "next-intl"

function CartMismatchBanner(props: {
  customer: StoreCustomer
  cart: StoreCart
}) {
  const { customer, cart } = props
  const t = useTranslations('common')
  const [isPending, setIsPending] = useState(false)
  const [dismissed, setDismissed] = useState(false)

  if (!customer || !!cart.customer_id || dismissed) {
    return null
  }

  const handleSubmit = async () => {
    try {
      setIsPending(true)

      await transferCart()
    } catch {
      // Transfer failed — dismiss the banner since cart works fine without it
      setDismissed(true)
    } finally {
      setIsPending(false)
    }
  }

  return (
    <div className="flex items-center justify-center small:p-4 p-2 text-center bg-warning/20 small:gap-2 gap-1 text-sm mt-2 text-warning-foreground">
      <div className="flex flex-col small:flex-row small:gap-2 gap-1 items-center">
        <span className="flex items-center gap-1">
          <AlertCircle className="inline" />
          {t('cartMismatch.error')}
        </span>

        <span>·</span>

        <Button
          variant="ghost"
          className="disabled:opacity-50 text-warning-foreground font-medium p-0 h-auto hover:bg-transparent"
          size="sm"
          disabled={isPending}
          onClick={handleSubmit}
        >
          {isPending ? t('cartMismatch.transferring') : t('cartMismatch.runTransfer')}
        </Button>
      </div>
    </div>
  )
}

export default CartMismatchBanner
